import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  IconButton,
  Popover,
  Button,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import DashportLogo from "../../../assets/dashport-logos/DASHPORT_color_horizontal.png";

const STORAGE_KEY = "dashport_winnersBoard_columnas";
const OPCIONES_COLUMNAS = [1, 2, 3, 4, 6];
const MAX_CARACTERES_NOMBRE = 24;
const COLUMNAS_DESDE_LAS_QUE_SE_ACORTA = 4;

function acortarNombre(nombre, columnasPorFila) {
  if (!nombre) return nombre;
  if (columnasPorFila < COLUMNAS_DESDE_LAS_QUE_SE_ACORTA) return nombre;
  if (nombre.length <= MAX_CARACTERES_NOMBRE) return nombre;
  return nombre.substring(0, MAX_CARACTERES_NOMBRE - 1).trimEnd() + "…";
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 20,
    backgroundColor: "#f4f4f4",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 15,
  },
  logo: {
    height: 40,
  },
  modalidadPaper: {
    padding: 10,
    marginBottom: 15,
  },
  modalidadTitulo: {
    fontWeight: "bold",
    marginBottom: 8,
    color: "#333",
  },
  categoriasGrid: {
    display: "grid",
    gap: 6,
  },
  categoriaBox: {
    minWidth: 0,
    border: "1px solid #ddd",
    borderRadius: 6,
    padding: 6,
    backgroundColor: "#ffffff",
  },
  categoriaTitulo: {
    fontWeight: "bold",
    marginBottom: 4,
    color: "#c62828",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  ganadorRow: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 0",
    fontSize: 12,
  },
  ganadorNombre: {
    flexGrow: 1,
    minWidth: 0,
    fontSize: 11,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  posicion: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: 10,
    color: "#fff",
    flexShrink: 0,
  },
  popoverContent: {
    padding: 15,
  },
}));

function colorPorPosicion(posicion) {
  if (posicion === 1) return "#c9a227";
  if (posicion === 2) return "#9e9e9e";
  if (posicion === 3) return "#a05a2c";
  return "#607d8b";
}

function leerColumnasGuardadas() {
  try {
    const guardado = window.localStorage.getItem(STORAGE_KEY);
    const numero = parseInt(guardado, 10);
    if (OPCIONES_COLUMNAS.indexOf(numero) >= 0) return numero;
  } catch (e) {
    console.log("No se pudo leer la preferencia de columnas:", e);
  }
  return 3;
}

export default function WinnersBoardCompact({ modalidadGroups, tituloEvento }) {
  const classes = useStyles();
  const [columnasPorFila, setColumnasPorFila] = useState(leerColumnasGuardadas);
  const [anchorEl, setAnchorEl] = useState(null);

  function elegirColumnas(n) {
    setColumnasPorFila(n);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(n));
    } catch (e) {
      console.log("No se pudo guardar la preferencia de columnas:", e);
    }
    setAnchorEl(null);
  }

  const grupos = modalidadGroups || [];

  return (
    <Paper className={classes.root}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <img src={DashportLogo} alt="Dashport" className={classes.logo} />
          <Typography variant="h5">{tituloEvento || "Resultados"}</Typography>
        </div>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <SettingsIcon />
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <div className={classes.popoverContent}>
            <Typography variant="body2" gutterBottom>
              Categorías por fila
            </Typography>
            {OPCIONES_COLUMNAS.map((n) => (
              <Button
                key={n}
                size="small"
                variant={columnasPorFila === n ? "contained" : "outlined"}
                color="primary"
                style={{ margin: 3, minWidth: 36 }}
                onClick={() => elegirColumnas(n)}
              >
                {n}
              </Button>
            ))}
          </div>
        </Popover>
      </div>

      {grupos.length === 0 && (
        <Typography variant="body1">Aún no hay ganadores para mostrar.</Typography>
      )}

      {grupos.map((modalidad) => (
        <Paper key={modalidad.codMod} className={classes.modalidadPaper}>
          <Typography variant="h6" className={classes.modalidadTitulo}>
            {modalidad.descripcionModalidad}
          </Typography>
          <div
            className={classes.categoriasGrid}
            style={{ gridTemplateColumns: "repeat(" + columnasPorFila + ", 1fr)" }}
          >
            {modalidad.categorias.map((categoria) => (
              <div key={categoria.cat + "|" + categoria.gen} className={classes.categoriaBox}>
                <Typography variant="subtitle2" className={classes.categoriaTitulo}>
                  {categoria.cat} — {categoria.generoLabel}
                </Typography>
                {categoria.ganadores.map((ganador, i) => (
                  <div key={i} className={classes.ganadorRow}>
                    <div
                      className={classes.posicion}
                      style={{ backgroundColor: colorPorPosicion(ganador.posicion) }}
                    >
                      {ganador.posicion}
                    </div>
                    <span>#{ganador.num}</span>
                    <span className={classes.ganadorNombre}>
                      {acortarNombre(ganador.nombre, columnasPorFila)}
                    </span>
                    <span>{ganador.tiempo}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Paper>
      ))}
    </Paper>
  );
}
